import { calculateLocatinVars } from '../../../libs/browser';
import { reloadAccountProps } from '../../../libs/state';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CommonIconButton from '../../../components/CommonIconButton';
import Context from '../../../provider';
import IconSuccess from '../../../assets/hkdc/icons/SuccessIcon';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import LogoFooterComponent from '../../../components/LogoFooterComponent';
import PageTitleContComponent from '../../../components/PageTitleContComponent';
import React, { useContext, useEffect } from 'react';
import config from '../../../config';
import useNotificationsCount from '../../../hooks/useNotificationsCount';
import './index.scss';

export default function WebSuccessPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const locationVars = calculateLocatinVars(location.pathname);

  const notificationNotReadCount = useNotificationsCount();

  const { init, dispatch, me } = useContext(Context);

  useEffect(() => {
    checkAccountStatus();
  }, []);

  // This page only allow logged in user
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [init, me, navigate]);

  const checkAccountStatus = async () => {
    await reloadAccountProps({ dispatch });
  };

  const handleBackHome = () => {
    navigate(`${config.basename}`, { replace: true });
  };

  return (
    (
      <div className='web-success-page'>
        <div className="content-container">
          <div className="black-block full-width">
            <PageTitleContComponent
              titleText={
                t(location.state.title)
              }
              titleTextStyle={{
                paddingLeft: '2.5rem'
              }}
              pageTitleIcon={
                <IconSuccess
                className="setting-tag-icon"
                size="large" />
              }
            />
          </div>

          <div className="full-width">
            <div
              className="web-max-container back-home-content-container">
              <div className="text-container">
                <div className='text-title'>
                  {t('success.title')}
                </div>
                <div className='back-home-text'>
                  {t(location.state.desc)}
                </div>
              </div>
              <div className="full-width">
                <CommonIconButton
                  text={t('success.back-btn')}
                  endIcon= {<KeyboardArrowRightIcon />}
                  backgroundColor= {'#004899'}
                  btnColor = "#ffffff"
                  btnWidth= "max-content"
                  padding = "0.75rem 1.25rem 0.75rem 2rem"
                  btnFontSize = "1rem"
                  btnFontWeight = "700"
                  onClick={handleBackHome}
                />
              </div>
            </div>
            <div className="black-block full-width">
              <LogoFooterComponent />
            </div>
          </div>
        </div>
      </div>
    )
  );
}